export const DOSSIERMEDICAL_LESSONS_AR = [
  {
    id: 'dossiermedical-1',
    numero: 1,
    titre: "فهم ملفك الطبي",
    sousTitre: "حقوقك القانونية",
    contexte: "ملفك الطبي يحتوي على تاريخك الصحي بالكامل. لك الحق في الاطلاع عليه — وهذا حق قانوني.",
    explication: [
      "**حق الاطلاع**: لك الحق في الحصول على نسخة من ملفك الطبي — في المستشفى أو عند طبيبك — في غضون 8 أيام عمل.",
      "**القانون**: المادة L1111-7 من قانون الصحة العامة تضمن لك هذا الحق. لا يمكن لأي طبيب رفضه.",
      "**التكلفة**: الاطلاع مجاني. النسخ الورقية قد تُكلّف رسوم الطباعة فقط.",
      "**كيفية الطلب**: راسل مستشفاك أو طبيبك خطياً (بريد إلكتروني أو رسالة مضمونة) مع وثيقة هويتك.",
      "**ما يحتويه الملف**: تقارير الاستشارات، نتائج الفحوصات، التشخيصات، الأدوية الموصوفة، ملخصات الإقامة في المستشفى.",
    ],
    question: "خلال كم يوماً يجب أن يُسلّمك المستشفى ملفك الطبي؟",
    options: [
      { id: 'a', text: "8 أيام عمل", correct: true },
      { id: 'b', text: "30 يوماً", correct: false },
      { id: 'c', text: "3 أشهر", correct: false },
    ],
    explication_reponse: "بموجب القانون، يجب تسليم ملفك الطبي في غضون 8 أيام عمل. إذا تجاوز الأجل، يمكنك رفع شكوى إلى ARS (وكالة الصحة الإقليمية).",
  },
  {
    id: 'dossiermedical-2',
    numero: 2,
    titre: "فضائي الصحي — Mon Espace Santé",
    sousTitre: "ملفك الطبي الرقمي",
    contexte: "Mon Espace Santé هو الملف الطبي الرقمي لكل مقيم في فرنسا. إليك كيفية استخدامه.",
    explication: [
      "**Mon Espace Santé** (monespacesante.fr): مساحة شخصية آمنة تحتوي على تاريخك الطبي الكامل — متاحة لك ولأطبائك.",
      "**الملف الطبي المشترك (DMP)**: داخل Mon Espace Santé، DMP يخزّن نتائج فحوصاتك، أدويتك، وتقارير أطبائك.",
      "**التحكم في الوصول**: أنت تتحكم في من يرى ملفك. يمكنك إخفاء وثائق بعينها حتى عن الأطباء.",
      "**في حالة الطوارئ**: الأطباء في المستعجلات يمكنهم الوصول إلى ملفك الطبي لإنقاذ حياتك — حتى بدون كلمة سرك.",
      "**التفعيل**: أُنشئ تلقائياً لكل شخص. فعّله على monespacesante.fr برقم ضمانك الاجتماعي.",
    ],
    question: "من يتحكم في الوصول إلى ملفك على Mon Espace Santé؟",
    options: [
      { id: 'a', text: "أنت — يمكنك إخفاء وثائق حتى عن الأطباء", correct: true },
      { id: 'b', text: "طبيبك المعالج وحده", correct: false },
      { id: 'c', text: "وزارة الصحة", correct: false },
    ],
    explication_reponse: "أنت صاحب ملفك الطبي. تتحكم تماماً في من يرى ماذا. فقط في حالة الطوارئ، يمكن للأطباء الوصول لإنقاذ حياتك.",
  },
  {
    id: 'dossiermedical-3',
    numero: 3,
    titre: "تنظيم وثائقك الصحية",
    sousTitre: "ورقياً ورقمياً",
    contexte: "نتائج الفحوصات، التقارير، التطعيمات... كيف تنظم كل هذه الوثائق لإيجادها عند الحاجة؟",
    explication: [
      "**الملف الورقي**: احتفظ بكل وثيقة طبية في ملف خاص مرتّب بالتاريخ — نتائج تحاليل، تقارير الأشعة، ملخصات الإقامة.",
      "**النسخة الرقمية**: صوّر كل وثيقة بهاتفك أو افحصها وخزّنها في سحابة (Google Drive أو iCloud). سهل الوصول في طوارئ.",
      "**دفتر التطعيمات**: احتفظ به — مطلوب عند السفر، التسجيل في المدرسة، بعض الوظائف.",
      "**التقارير المهمة**: الفحص السنوي، نتائج التصوير، تقارير ما قبل العمليات — لا ترميها أبداً.",
      "**سهولة الإيجاد**: عنوِن كل وثيقة بوضوح قبل رفعها رقمياً: مثلاً 'تحليل_دم_مارس2026.pdf'.",
    ],
    question: "ما أفضل طريقة للاحتفاظ بنتائج فحوصاتك الطبية؟",
    options: [
      { id: 'a', text: "نسخة ورقية مرتّبة + نسخة رقمية في السحابة", correct: true },
      { id: 'b', text: "تركها في عيادة الطبيب فقط", correct: false },
      { id: 'c', text: "لا داعي للاحتفاظ بها بعد الاستشارة", correct: false },
    ],
    explication_reponse: "الاحتفاظ بنسختين — ورقية ورقمية — يضمن لك الوصول إليها في أي ظرف. الوثائق الطبية قد تكون مهمة جداً سنوات بعد تاريخها.",
  },
  {
    id: 'dossiermedical-4',
    numero: 4,
    titre: "فهم الوصفة الطبية",
    sousTitre: "قراءة وثيقة مهمة",
    contexte: "الطبيب أعطاك وصفة. كيف تقرأها وما يجب أن تعرفه قبل الذهاب إلى الصيدلانية؟",
    explication: [
      "**صلاحية الوصفة**: 3 أشهر بشكل عام للأدوية العادية. بعض الأدوية (المخدرات، المضادات الحيوية) لها صلاحيات أقصر.",
      "**الاختصارات الشائعة**: 1cp/j = حبة واحدة في اليوم، matin/soir = صباحاً/مساءً، à jeun = على معدة فارغة.",
      "**الصيدلاني حليفك**: لا تتردد في سؤاله عن طريقة الاستخدام، التفاعلات مع أدوية أخرى، الآثار الجانبية.",
      "**الأدوية الجنيسة (générique)**: غالباً أرخص ومتاحة كبديل. الصيدلاني يمكنه استبدال الدواء المسمّى بجنيسه.",
      "**في حالة فقدان الوصفة**: اتصل بطبيبك لإعادة كتابتها. الصيدلاني لا يمكنه صرف دواء بدون وصفة قانونية.",
    ],
    question: "ما هي صلاحية الوصفة الطبية العادية في فرنسا؟",
    options: [
      { id: 'a', text: "3 أشهر", correct: true },
      { id: 'b', text: "6 أشهر", correct: false },
      { id: 'c', text: "سنة كاملة", correct: false },
    ],
    explication_reponse: "الوصفة العادية صالحة 3 أشهر. بعض الأدوية لها مدة أقصر. لا تنتظر طويلاً — اذهب إلى الصيدلانية قبل انتهاء الصلاحية.",
  },
];
